<template>
	<div class="collect">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>我的收藏</span>
			<span @click="isDelete=false" v-if="isDelete">完成</span>
			<span @click="isDelete=true" v-else>管理</span>
		</div>
		<!-- 收藏列表 -->
		<div class="listbooto">
			<div v-if="list.length==0" class="none">
				<img src="../../assets/none.png" alt="">
				<span>这里空空如也~</span>
			</div>
			<div class="list" v-for="item in list">
				<van-checkbox v-model="item.ischeck" v-if="isDelete" @click="chooseChange(item.id)" :id=item.id checked-color="#f1452f"
				 icon-size="1rem" ref="checkboxGroup"></van-checkbox>
				<div class="heziimg"><img :src="'http://backstage.jbj-china.com.cn/uploads'+item.goods.image" alt=""></div>
				<van-card @click="yaosheng(item.goods.id)" v-if="!isDelete">

					<div slot="title" class="van_title">
						<span>{{item.goods.title}}</span>
					</div>
					<div class="zujinhsae" slot="desc">
						<span>
							<span v-if="item.goods.category_id == 1">租金</span>
							<span v-else>价格:</span>
							<span class="money">¥{{item.goods.price}}</span>
							<span v-if="item.goods.category_id == 1" class="yueleja">/月</span>
							<span v-if="item.goods.category_id == 1" class="qingdong">起</span>
						</span>
						<span>
							
						</span>
						<span class="saite">
							<van-icon name="shopping-cart-o" size="0.9rem" color="#fff" />
						</span>
					</div>

					<div class="gongqi-xing" slot="desc" v-if="item.goods.category_id == 1">
						<span v-if="item.goods.goods_work == 7">工期7-10天</span>
						<span v-if="item.goods.goods_work == 15">工期15-20天</span>
						<span v-if="item.goods.goods_work == 30">工期30-40天</span>
						<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.goods.hot_num" readonly />
					</div>

				</van-card>
				<van-card v-else>
					ssdsd
					<div slot="title" class="van_title" @click="chooseChange(item.id)">
						<span>{{item.goods.title}}</span>
					</div>

					<div class="zujinhsae" slot="desc">
						<span>

							<span v-if="item.category_id == 1">租金</span>
							<span v-else>价格:</span>
							<span class="money">¥{{item.goods.price}}</span><span class="yueleja">/月<span class="qingdong">起</span>

							</span>

						</span>
						<!-- <span v-if="item.category_id == 1">起/年</span> -->

						<span class="saite">
							<van-icon name="shopping-cart-o" size="0.9rem" color="#fff" /></span>

					</div>

					<!-- <div class="vangrid-bottom" slot="desc" >	 </div> -->
					<div class="gongqi-xing" slot="desc">
						<span v-if="item.goods.goods_work == 7">d工期7-10天</span>
						<span v-if="item.goods.goods_work == 15">工期15-20天</span>
						<span v-if="item.goods.goods_work == 30">工期30-40天</span>
						<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.goods.hot_num" readonly />
					</div>

					<!-- <div slot="desc" class="van_desc">
					<span>浏览量{{item.goods.browse}}</span>
				</div> -->
					<!-- <div slot="price" clss="van_price">
					<span v-if="item.goods.category_id == 1" class="active">{{item.goods.price}}</span>
					<span class="active" v-else>¥{{item.goods.price}}</span>
				</div> -->
				</van-card>




			</div>

		</div>



		<!-- 猜你喜欢 -->
		<!-- <van-divider :style="{ color: '#000', borderColor: '#ccc', margin: '0.5rem 0 0 0'}">猜你喜欢</van-divider>
		<div class="action">
			<Like></Like>
		</div> -->
		<!-- 结算栏 -->
		<div class="settle" v-if="isDelete">
			<div class="all">
				<van-checkbox v-model="AllChecked" @click="checkAll" checked-color="#f1452f" icon-size="1rem">
				</van-checkbox>
				<span>全选</span>
			</div>
			<div>
				<van-button color="#F1452F" round size="mini" type="default" @click="destroy">删除</van-button>
			</div>
		</div>

	</div>
</template>

<script>
	import Like from '@/components/like/like'
	export default {
		inject: ['reload'],
		data() {
			return {
				AllChecked: false,
				isDelete: false,
				asefer: false,
				dsadsa: true,
				isDeletee: true,
				list: [],
				selectedData: []
			}
		},
		created() {

			this.destroy();
			this.$axios.post(baseUrl + '/mobile/Base/userGoodsCollection', {
				token: localStorage.getItem('Authorization')
			}).then((res) => {
				if (res.data.code == 2) {
					for (var i = 0; i < res.data.data.length; i++) {
						res.data.data[i].ischeck = false;
					}
					this.list = res.data.data;
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		methods: {
			yaosheng(id) {
				this.$router.push({
					path: '/detail',
					query: {
						id: id
					}
				})

			},
			// 单选的change事件
			chooseChange(id) {


				// document.getElementById(id).setAttribute('aria-checked',true);
				// // van-checkbox__icon van-checkbox__icon--round van-checkbox__icon--checked
				// document.getElementById(id).firstChild
				// console.log(id,document.getElementById(id),	document.getElementById(id).firstChild.appendChild())
				if (this.selectedData.indexOf(id) > -1) {
					this.selectedData.splice(this.selectedData.indexOf(id), 1);
				} else {
					this.selectedData.push(id);
				}
				if (this.selectedData.length < this.list.length) {
					this.AllChecked = false;
				} else {
					this.AllChecked = true;
				}

			},
			// 全选和反选
			checkAll(e) {

				for (var i = 0; i < this.list.length; i++) {
					let list = this.list[i];
					if (this.AllChecked) {
						list.ischeck = false;
						this.selectedData = [];
					} else {
						list.ischeck = true;
						if (this.selectedData.indexOf(list.id) < 0) {
							this.selectedData.push(list.id);
						}
					}
				}
			},
			//删除
			destroy() {
				var that = this;
				if (that.selectedData.length == 0) {
					// that.$toast('没有可取消的商品')
				} else {
					that.$axios.post(baseUrl + '/mobile/Base/deleteGoodsCollection', {
						id: that.selectedData
					}).then(function(res) {
						if (res.data.code == 9) {
							that.$toast(res.data.msg);
							that.reload();
						}
					}).catch(function(err) {
						console.log(err);
					});
				}
			}
		},
		components: {
			Like
		}
	}
</script>

<style scoped>
	.collect {
		background: #f2f2f2;
		padding-top: 2rem;
	}

	.collect .list {
		display: flex;
		background: #fff;
		margin-top: 0.8rem;
	}

	.collect .none {
		margin: 3rem 0;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.collect .none img {
		max-width: 10rem;
		max-height: 10rem;
	}

	.collect .none span {
		margin-top: 2rem;
		font-size: 0.8rem;
		color: #B0B0B0;
	}

	.collect .list .van-checkbox {
		display: flex;
		justify-content: center;
		width: 1.5rem;
	}

	.collect .list .van-card {
		width: calc(100% - 1.5rem);
		text-align: left;
		margin-top: 0;
		background: #fff;
		padding: 0.5rem 0.5rem 0 0.3rem;
	}

	.collect .list .van-image {
		height: auto !important;
		border-radius: 0.3rem;
		overflow: hidden;
	}

	.collect .list .van-card__price .active {
		font-size: 0.9rem;
		color: #F1452F;
		float: right;
	}

	.collect .list .van_desc {
		color: #bfbfbf;
		margin-top: 0.5rem;
	}

	.collect .list .van-card__price {
		color: #bfbfbf;
		margin-top: 1rem;
		width: 100%;
	}

	.collect .list .van-card__price button {
		float: right;
		color: #7f7f7f;
	}

	.collect .action {
		background: #fff;
		border-radius: 0.3rem;
	}

	.collect .settle {
		height: 3rem;
		width: 100%;
		background: #fff;
		position: fixed;
		bottom: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 1rem;
		box-sizing: border-box;
		font-size: 0.7rem;
		z-index: 666;
		border-top: 1px solid #dedede;
	}

	.collect .settle .all {
		display: flex;
	}

	.collect .settle .all span {
		margin-left: 0.5rem;
	}

	.zujinhsae>>>van-icon {
		color: red !important;
	}

	.saite i {
		float: right;
		background: red;
		border-radius: 50%;
		height: 1.2rem;
		width: 1.2rem;
		text-align: center;
		line-height: 1.2rem;
	}

	.money {
		font-size: 0.9rem;
		color: #f1452f;
	}

	.yueleja {
		color: red;
	}

	.qingdong {
		position: absolute;
		transform: scale(0.8);
		color: red;
		line-height: 1.35rem;

	}

	.zujinhsae {
		padding-left: 0.5rem;

		justify-content: space-between;
		display: flex;
		margin-top: 1rem;

	}

	.collect .list .van-card {
		width: 100%;
	}

	.gongqi-xing {
		position: relative;
		padding: 0.7rem 0 0 0.5rem;
		display: flex;
		-webkit-box-pack: justify;
		justify-content: space-between;

		padding-bottom: 0.5rem;
	}

	.gongqi-xing .van-rate {
		position: relative;
		top: 0.1rem;
	}

	.van-card__thumb {
		/* height: 7rem; */
	}

	.collect .list .van-card {

		padding: 0.3rem 1rem 0 1rem !important;
	}

	.van-card__thumb img {
		/* position: relative; */
		/* top: 0.1rem; */
		/* height: 5.3rem; */
		/* max-height: 5.5rem; */

	}

	.collect .list .van-checkbox {
		width: 2.5rem;
		position: relative;
		left: 0.5rem;
	}

	.van-card__header {}

	.van-card__thumb>>>div:nth-child(1) {
		height: 5rem;
	}

	.collect .list .van-card {

		padding: 0;
	}

	.saite {
		position: relative;

	}

	.van-card__thumb {
		display: flex;
		align-items: center;
	}

	.van-card__header {
		align-items: center;
	}

	.van_title span {
		position: relative;
		top: 0.5rem;
	}

	.van-card__content div:nth-child(1) {
		padding: 0 0 0 0.5rem;
	}

	.hezihs {
		height: 3rem;
	}

	.heziimg img {
		height: 5.3rem;
		width: 5.3rem;

	}

	.listbooto {
		padding-bottom: 3rem;
	}

	.heziimg {
		height: 6.5rem;
		padding-left: 1rem;
		display: flex;
		align-items: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/collect.vue